import type {
  OrganizationData,
  OrganizationDataState,
} from '@/viewmodel/features/user/state/organizationTypes';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: OrganizationDataState = {
  data: null,
  loading: false,
  loaded: false,
};

const organizationSlice = createSlice({
  name: 'organizationData',
  initialState,
  reducers: {
    setOrganizationData: (state, action: PayloadAction<OrganizationData>) => {
      state.data = action.payload;
      state.loading = false;
      state.loaded = true;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setLoaded: (state, action: PayloadAction<boolean>) => {
      state.loaded = action.payload;
    },
  },
});

export const { setOrganizationData, setLoading, setLoaded } = organizationSlice.actions;
export default organizationSlice.reducer;
